import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobStore } from '@/features/jobs/JobStore'
import { task } from 'mobx-task'

/**
 * View model for closing a job as one of its collaborators.
 */
export class CloseJobAsCollaboratorDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    public readonly job: Job,
    private readonly _jobStore: JobStore,
  ) {}

  /**
   * Closes the job.
   */
  submit = task.resolved(async () => {
    await this._jobStore.close(this.job)

    this.modal.close()
  })
}
